/**
 * 피니아 전용 state의 formData를 이용해 key 값을 특정한다.
 */
export const getFormValueForPinia = (formData, key) => formData.value[key];
/**
 * 피니아 전용 state의 formData를 이용해 값을 입력한다.
 * vuex는 action > mutation까지 가야 하기에 pinia와 패턴이 다르다
 * 이것은 pinia 전용이다
 */
export const setFormValueForPinia = (formData, key, _value) => {
    const value = _value instanceof FocusEvent
        ? _value.target.value
        : _value;
    // eslint-disable-next-line no-param-reassign
    formData.value[key] = value;
};
/**
 * 비동기 폼 검증
 * 엘리먼트 ref를 배열로 받아서 검증한다
 */
export const validateForm = async (itemList) => {
    const tmp = [];
    itemList.forEach((item) => {
        tmp.push(item.validate());
    });
    // wait..
    const promiseList = await Promise.all(tmp);
    return {
        isValid: promiseList.every((item) => item.length === 0),
        list: promiseList,
    };
};
